import * as types from "./mutation-types";

export default {
  [types.SET_REMEMBER_ME](state, status) {
    state.rememberMe = status;
  },
  [types.SET_GLOBAL_CONDITIONS](state, status) {
    state.globalConditions = status;
  },
  [types.SET_SIGN_IN](state, flag) {
    state.isSignIn = flag;
  },
  [types.SET_SHOW_SIGNIN](state, flag) {
    state.showSignIn = flag;
  },
  [types.SET_SHOW_SIGNUP](state, flag) {
    state.showSignUp = flag;
  },
  // token
  [types.SET_AUTH](state, auth) {
    state.auth = auth;
  },
  // current user
  [types.SET_USER](state, user) {
    state.user = user;
  },
  [types.SET_BRIEFS](state, briefs) {
    state.briefs = briefs;
  },
  [types.SET_DETAIL](state, detail) {
    state.detail = detail;
  },
  [types.SET_LISTSTYLE](state, status) {
    state.listStyle = status;
  },
  [types.SET_LISTWHAT](state, status) {
    state.listWhat = status;
  },
  [types.SET_SNACK_INFO](state, status) {
    state.snackInfo = status;
  },
};
